export default __webpack_public_path__ + "static/media/dyar_mobil_logo.0b509eef.png";